import { render, staticRenderFns } from "./DownloadBtn.vue?vue&type=template&id=0fd89562&scoped=true"
import script from "./DownloadBtn.vue?vue&type=script&lang=js"
export * from "./DownloadBtn.vue?vue&type=script&lang=js"
import style0 from "./DownloadBtn.vue?vue&type=style&index=0&id=0fd89562&prod&lang=scss"
import style1 from "./DownloadBtn.vue?vue&type=style&index=1&id=0fd89562&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fd89562",
  null
  
)

export default component.exports